import { Button, Modal, Stack } from '@mui/material'
import ArrowLeftNewSvg from '~/@ui/_sharedSvgs/ui/ArrowLeftNew.svg?react'
import { AddFunds } from '../add-funds/AddFunds'
import { useForm } from 'react-hook-form'

type Props = {
  isOpen: boolean
  handleClose: () => void
  variableSymbol: string | null
}

export const AddFundsModal = ({
  isOpen,
  handleClose,
  variableSymbol,
}: Props) => {
  const { watch, control } = useForm({
    defaultValues: {
      amount: 50,
    },
  })

  const amount = Number(watch('amount'))

  return (
    <Modal open={isOpen} onClose={handleClose} className="overflow-auto">
      <Stack className="w-full min-h-screen pt-4 pb-28 bg-zWhite100 ">
        <Stack className="w-full max-w-[768px] self-center">
          <Button className="w-16 mx-6 bg-zWhite200" onClick={handleClose}>
            <ArrowLeftNewSvg />
          </Button>

          <AddFunds
            className="pb-28"
            variableSymbol={variableSymbol}
            control={control}
            amount={amount}
          />
        </Stack>
      </Stack>
    </Modal>
  )
}
